import React from 'react';

const JsonLdApplication = data => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
);

export default JsonLdApplication;



// WEBPACK FOOTER //
// ./src/shared/components/JsonLdApplication/JsonLdApplication.js